// extracted by mini-css-extract-plugin
export default {"statsTab":"Stats_statsTab__8mARF","statsContent":"Stats_statsContent__bHPdI","tabBar":"Stats_tabBar__btu5U","tab":"Stats_tab__oRDvA","activeTab":"Stats_activeTab__nCFTm"};